import type { Role } from '@repo/api-gw-sdk';

import {
  apps,
  sourceAccountId,
  dataClasses,
  environment,
  resourceName,
  resourceType,
  sourceRegion,
  subnets,
  vpc,
  resourceId,
  cloudProvider,
  resourceGroupName,
  tagKeys,
  tagKeyValues,
} from '@/components/queryBuilder/properties';
import type { PermissionDescriptor } from '@/contexts/permissions';
import type { FilterProperty } from '@/types/advanceFilter';

export const dataAccessConditionSupportedProperties: FilterProperty[][] = [
  [resourceType, dataClasses, environment, apps],
  [
    cloudProvider,
    sourceAccountId,
    sourceRegion,
    vpc,
    subnets,
    resourceGroupName,
  ],
  [resourceName, resourceId],
  [tagKeys, tagKeyValues],
];

export const getAssignedDataAccessRule = (
  permission: PermissionDescriptor,
  role: Role
) =>
  (permission.isConditional &&
    Object.values(role.dataAccessRules || {}).find((rule) =>
      (permission.conditionalScopesOverrides || permission.scopes).every(
        (scope) => rule.scopes.includes(scope)
      )
    )) ||
  undefined;
